import { render, staticRenderFns } from "./Plant.vue?vue&type=template&id=3854e664&scoped=true&"
import script from "./Plant.vue?vue&type=script&lang=js&"
export * from "./Plant.vue?vue&type=script&lang=js&"
import style0 from "./Plant.vue?vue&type=style&index=0&id=3854e664&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3854e664",
  null
  
)

export default component.exports